import type { AxiosRequestConfig } from '@deltax/idp-api-client'

import { apiClient } from './client'
import { handleError } from './apiErrorHandler'

apiClient.axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => handleError(error),
)

class Api {
  async get<T>(url: string, params?: Record<string, unknown>, config?: AxiosRequestConfig): Promise<T> {
    const requestConfig: AxiosRequestConfig = { params, ...config }
    const response = await apiClient.axiosInstance.get<T>(url, requestConfig)
    return response.data as T
  }

  async post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    const response = await apiClient.axiosInstance.post<T>(url, data, config)
    return response.data as T
  }

  async patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    const response = await apiClient.axiosInstance.patch<T>(url, data, config)
    return response.data as T
  }
}

const api = new Api()

export default api
export { apiClient, authService } from './client'
